import Button from './Button';
import RadioText from './RadioText';
import useTheme from '../hook/useTheme';

interface IProps {
  isSelected: boolean;
  text: string;
  onClick: () => void;
}

export default function AlertRadioButtonV4({
  isSelected,
  text,
  onClick,
}: IProps) {
  const {isLightMode} = useTheme();

  return (
    <Button
      className={cn('h-56 w-full rounded-12 px-12', {
        'bg-grey-04': isSelected && !isLightMode,
        'bg-grey-02': isSelected && isLightMode,
      })}
      onClick={onClick}
    >
      <RadioText
        gap={12}
        isSelected={isSelected}
        text={text}
        textClassName="s14-medium-white light:text-black"
      />
    </Button>
  );
}
